export const HIDE_REDIS_INSPECTOR =
  String(import.meta.env.VITE_HIDE_REDIS_INSPECTOR ?? "").toLowerCase() ===
  "true";
